import { GET_MY_BUSINESS_DOCTORS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data?: {
        id: string;
        name: {
            l: string;
            f: string;
        };
        specilization: string;
        type?: 'doctor' | 'speciality';
    }[];
    error?: string;
}

export default (): Promise<Response> => {
    return fetchWithRefresh(GET_MY_BUSINESS_DOCTORS).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to GET_MY_BUSINESS_DOCTORS');
        }
    });
};
